import type { FC } from "react";

import type { Placement } from "../../../../common-ui/popover/FreightPortalPopover";
import { CalculatePrice } from "../../../../common-ui/pricing/CalculatePrice";
import { useCalculatePrice } from "../../../../common/pricing/useCalculatePrice";
import { trackEvent } from "../../../../common/tracking/trackerService";
import type { BookingFormState } from "../../../../services/update-form/updateFormReducer";
import { transformToInput } from "../utils/transformToInput";
import { isPriceOutdated } from "./isPriceOutdated";
import { transformFormStateToCalculatePriceInput } from "./transformFormStateToCalculatePriceInput";

export interface CalculatePriceProps {
  formState?: BookingFormState;
  placement?: Placement;
}

export const CalculatePriceForDetails: FC<CalculatePriceProps> = ({
  formState,
  placement,
}) => {
  const { result, errors, fetchPrice, loading, priceOutdated } =
    useCalculatePrice(formState, isPriceOutdated);

  const onClick = () => {
    trackEvent({ category: "Details", action: "CalculatePrice" });

    if (formState) {
      fetchPrice(
        {
          bookings: [
            transformFormStateToCalculatePriceInput(
              transformToInput(formState),
            ),
          ],
        },
        formState,
      );
    }
  };

  return (
    <CalculatePrice
      errors={errors}
      priceOutdated={priceOutdated}
      result={result}
      loading={loading}
      onClick={onClick}
      placement={placement}
      trackerCategory={"Details"}
      disabled={!formState?.sailing}
    />
  );
};
